<script>
import { find } from 'lodash';
import { Menu } from 'element-ui';

export default {
  mixins: [Menu],
  name: 'nuttrema-el-menu',
  methods: {
    initOpenedMenu() {
      const index = this.activeIndex;
      const parentTypeItem = find(this.items, item => item.type === 'parent');
      const activeItem = parentTypeItem && index.startsWith(parentTypeItem.index) ? parentTypeItem : this.items[index];

      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;

      const indexPath = activeItem.indexPath;

      // expand all submenus of the menu item
      indexPath.forEach((index) => {
        const submenu = this.submenus[index];
        return submenu && this.openMenu(index, submenu.indexPath);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/navigation/nuttrema-el-menu.vue